<template>
  <div>
    <div class="text-end" @click="addNewRow()"><font-awesome-icon :icon="['fas', 'circle-plus']" /></div>
    <ul class="list-group" v-if="this.dataRows.length > 0">
      <li style="" v-for="(row, index) of this.dataRows" :key="index" v-bind:class="getClass(row)">
        <Row :row="row" :stockId="this.stockId" :name="this.name"/>
      </li>
    </ul>
  </div>
</template>
  
<style>
.light-grren-border{
  border: 1px solid #16A34A !important;
  border-radius: 8px;
}
.light-red-border{
  border: 1px solid #DC2626 !important;
  border-radius: 8px;
}
</style>

<script>

import Row from '@/views/stock/view/tracker/CallRow.vue';

export default {
    name: 'tracker-call',
    components: {
      Row
    },
    data() {
        return {
          dataRows: this.rows.filter(rows => rows.rule.includes(this.stockId) && rows.type_id == 2)
        }
    },
    props: {
        rows: { type: Object },
        stockId: { type: Number },
        name: { type: String },
    },
    methods: {
      getClass(row){
        let extraClass = '';
        if(row.call_type == 1){
          extraClass = ' light-grren-border';
        } else if(row.call_type == 2){
          extraClass = ' light-red-border';
        }
        return 'list-group-item bg-transparent' + extraClass;
      },
      addNewRow(){
        this.dataRows = [...this.dataRows, {
          call_type: '',
          rule: "",
          value: {
            value: '',
          }
        }];
      },
    },
    setup() {
    },
}

</script>